export enum EmailErrors {
  SEND = 'emails/sendEmail'
}
